import * as React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import ComplienceIcon from '@mui/icons-material/FactCheck';
import DocumentIcon from '@mui/icons-material/DocumentScannerRounded';
import LegalIcon from '@mui/icons-material/Gavel';
import PayrollIcon from '@mui/icons-material/Receipt';
import EmployeeIcon from '@mui/icons-material/PeopleAlt';
import HrIcon from '@mui/icons-material/EmojiPeople';
import WorkEvidenceIcon from '@mui/icons-material/WorkOutline';
import WorkEvidenceApprovalIcon from '@mui/icons-material/Checklist';
import JobIcon from '@mui/icons-material/HubOutlined';
import BranchIcon from '@mui/icons-material/AccountTreeOutlined';
import ReportsIcon from '@mui/icons-material/Assessment';
import ContractsIcon from '@mui/icons-material/Handshake';

const iconMap: Record<string, React.ReactElement> = {
    '<HomeIcon />': <HomeIcon/>,
    'HomeIcon': <HomeIcon/>,
    'Home': <HomeIcon/>,
    '<ComplienceIcon />': <ComplienceIcon/>,
    'ComplienceIcon': <ComplienceIcon/>,
    'Complience': <ComplienceIcon/>,
    '<DocumentIcon />': <DocumentIcon/>,
    'DocumentIcon': <DocumentIcon/>,
    'Documents': <DocumentIcon/>,
    '<LegalIcon />': <LegalIcon/>,
    'LegalIcon': <LegalIcon/>,
    'Legal': <LegalIcon/>,
    '<PayrollIcon />': <PayrollIcon/>,
    'PayrollIcon': <PayrollIcon/>,
    'Payroll': <PayrollIcon/>,
    '<HrIcon />': <HrIcon/>,
    'HrIcon': <HrIcon/>,
    'Human Resources': <HrIcon/>,
    '<EmployeeIcon />': <EmployeeIcon/>,
    'EmployeeIcon': <EmployeeIcon/>,
    'Employee': <EmployeeIcon/>,
    'Work Evidence': <WorkEvidenceIcon/>,
    'WorkEvidenceIcon': <WorkEvidenceIcon/>,
    '<WorkEvidenceIcon />': <WorkEvidenceIcon/>,
    'Work Evidence Approvals': <WorkEvidenceApprovalIcon/>,
    'WorkEvidenceApprovalIcon': <WorkEvidenceApprovalIcon/>,
    '<WorkEvidenceApprovalIcon />': <WorkEvidenceApprovalIcon/>,
    'Job positions': <JobIcon/>,
    'JobIcon': <JobIcon/>,
    '<JobIcon />': <JobIcon/>,
    'Branches': <BranchIcon/>,
    'BranchIcon': <BranchIcon/>,
    '<BranchIcon />': <BranchIcon/>,
    '<IncompleteCircleIcon />': <ReportsIcon/>,
    'IncompleteCircleIcon': <ReportsIcon/>,
    'ReportsIcon': <ReportsIcon/>,
    '<ReportsIcon />': <ReportsIcon/>,
    'Reports': <ReportsIcon/>,
    'ContractsIcon': <ContractsIcon/>,
    '<ContractsIcon />': <ContractsIcon/>,
    'Contracts': <ContractsIcon/>
};

export const mapIconStringToComponent = (
    iconString: string | React.ReactElement
): React.ReactElement => {
    if (React.isValidElement(iconString)) {
        return iconString;
    }
    if (typeof iconString === 'string') {
        return iconMap[iconString] || <HomeIcon/>;
    }
    return <HomeIcon/>;
};
